import React, { useState, useEffect } from 'react';
import { FaUserCircle, FaCog, FaEdit, FaSave } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import './PdfUpload.css';
import './Textextraction.css';
import { extractText } from '../../api/api';
 
const TextExtraction = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [editingText, setEditingText] = useState(false);
  const [textContent, setTextContent] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [lessonTexts, setLessonTexts] = useState([]);
 
  const location = useLocation();
  const navigate = useNavigate();
  const {
    selectedOptions = [],
      selectedLessons = [],
    completedSteps = [],
     pdfFiles = [],
  pdfPreviews = [],
    radioSelection = '',
    currentStepIndex = 0,
  details = [],
    fileName = '10th_Science_TM.pdf',
    file = null,
       previousState = {},
       currentStep='',
       stepFlow
  } = location.state || {};
 
  const userEmail = 'Eezeelearn@gmail.com';
 
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);
  const handleSignOut = () => {
       navigate(`/signin`);
  };
 
  const handleFileChange = async (e) => {
    const fileToUpload = e.target?.files?.[0] || file;
    if (!fileToUpload) return;
 
    try {
      const data = await extractText(fileToUpload);
      console.log("Backend response:", data);
 
      if (data.status === 'success') {
        setTextContent(data.full_text || '');
        setLessonTexts(data.lessons || []);
      } else {
        alert(data.message || 'Extraction failed.');
      }
    } catch (err) {
      alert('Extraction failed.');
      console.error('Error:', err);
    }
  };
 
  useEffect(() => {
    if (file) {
      handleFileChange({ target: { files: [file] } });
    }
  }, [file]);
 
  const handleTextChange = (e, index) => {
    const updated = [...lessonTexts];
    updated[index].content = e.target.value;
    setLessonTexts(updated);
  };
 
  const handleEditClick = (index) => setEditingIndex(index);
  const handleSave = (index) => {
    alert(`Lesson ${index + 1} saved!`);
    setEditingIndex(null);
  };
  const handleSaveAll = () => {
    alert('All lessons saved!');
    setEditingIndex(null);
  };
 
   const handleBack = () => {
    navigate('/upload', { state: { pdfFiles,currentStepIndex,pdfPreviews,details,radioSelection,stepFlow,selectedOptions, completedSteps, fileName, ...previousState } });
  };
 
 
   const handleNext = () => {
    navigate('translation', { state: { selectedOptions, completedSteps: [...completedSteps, 'Text Extraction'], fileName } });
  };
 
  return (
    <div className="page-container">
      <div className="sidebar">
        <div className="sidebar-profile">
          <FaUserCircle className="sidebar-profile-icon" onClick={toggleDropdown} />
          <div className="sidebar-profile-name">{userEmail}</div>
          {dropdownOpen && (
            <div className="profile-dropdown">
              <div className="dropdown-item">Change Password</div>
              <div className="dropdown-item">Account Settings</div>
            </div>
          )}
        </div>
 
        <div className="sidebar-menu">
          <div className="sidebar-item" onClick={() => alert('Show uploaded PDFs with days')}>My Projects</div>
          <div className="sidebar-item" onClick={() => navigate('/pdf-upload')}>New Project</div>
 
          <div className="sidebar-section">
            <div className="sidebar-item section-title">{fileName}</div>
            <div className="sidebar-submenu">
              <div className="sidebar-subitem enabled completed">PDF Upload</div>
              {stepFlow.map((step, index) => (
                <div
                  key={index}
                  className={`sidebar-subitem enabled ${completedSteps.includes(step) ? 'completed' : ''} 
          ${step === currentStep ? 'current-step' : ''} 
          enabled`}>
                  {step}
                </div>
              ))}
            </div>
          </div>
 
          <div className="sidebar-item" onClick={toggleSettings}>
            <FaCog style={{ marginRight: '8px' }} /> Settings
          </div>
          {settingsOpen && (
            <div className="sidebar-submenu">
              <div className="sidebar-subitem">Change Password</div>
              <div className="sidebar-subitem">Account Settings</div>
            </div>
          )}
        </div>
 
        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>
 
      <div className="pdf-container">
 
        {/* File Upload Input */}
       
 
        <div className="preview-panel">
          <div className="preview-container">
            <div className="preview-item">
              <div className="file-name">Extracted Text Preview </div>
              {!editingText ? (
                <div className="extracted-text">
                  <pre>{textContent}</pre>
                  {/*<FaEdit className="edit-icon-extract" onClick={() => setEditingText(true)} /> */}
                </div>
              ) : (
                <textarea
                  value={textContent}
                  onChange={(e) => setTextContent(e.target.value)}
                  onBlur={() => setEditingText(false)}
                  className="editable-textarea"
                  rows={12}
                />
              )}
            </div>
          </div>
 
          <div className="right-side-container">
            <label className="lesson-checkbox select-all-checkbox">
  <input
    type="checkbox"
    checked={lessonTexts.every(text => text.checked)}
    onChange={(e) => {
      const updated = lessonTexts.map(text => ({
        ...text,
        checked: e.target.checked
      }));
      setLessonTexts(updated);
    }}
  />
  <span>Select All Lessons</span>
</label>
 
            {lessonTexts.map((text, index) => (
              <div className="lesson-preview-box" key={index}>
                <div className="lesson-title">{text.title || `Lesson ${index + 3}`}</div>
                {editingIndex === index ? (
                  <textarea
                    className="editable-textarea"
                    value={text.content}
                    onChange={(e) => handleTextChange(e, index)}
                    onBlur={() => setEditingIndex(null)}
                  />
                ) : (
                  <div className="extracted-text">
                   <div className="lesson-actions">
                  <label className="lesson-checkbox">
    <input
      type="checkbox"
      checked={text.checked || false}
      onChange={() => {
        const updated = [...lessonTexts];
        updated[index].checked = !updated[index].checked;
        setLessonTexts(updated);
      }}
    />
    <span>Select lesson</span>
  </label>
  <FaEdit className="edit-icon" onClick={() => handleEditClick(index)} />
                    <FaSave className="save-icon" onClick={() => handleSave(index)} />
 
                    </div>
                    <pre>{text.content}</pre>
                   
                  </div>
                )}
              </div>
            ))}
            {lessonTexts.length > 0 && (
              <button className="save-all-button" onClick={handleSaveAll}>
                Save All
              </button>
            )}
          </div>
        </div>
 
        <div className="footer-buttons">
          <button className="action-btn" onClick={handleBack}>Back</button>
          <button
  className="action-btn"
  onClick={() =>
    navigate('/Translation', {
      state: {
        selectedOptions,
        stepFlow,
        currentStep:'Translation',
        completedSteps: [...completedSteps, 'Text Extraction'],
        currentStepIndex: 0,
         currentStep: stepFlow[0], 
        fileName,
        selectedLessons: lessonTexts.filter(text => text.checked)
      }
    })
  }
>
  Next
</button>
 
        </div>
      </div>
    </div>
  );
};
 
export default TextExtraction;